import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { concatMap, Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';

import { ClientNoteModel } from '../../model';

@Injectable({
  providedIn: 'root',
})
export class ClientNoteService {
  constructor(private http: HttpClient) {}

  public createClientNote(clientId: string, body: string): Observable<void> {
    return this.http.post<void>(`${environment.apiEndpoint}/account/client-note/${clientId}`, body);
  }

  public getClientNotesList(clientId: string): Observable<ClientNoteModel[]> {
    return this.http.get<ClientNoteModel[]>(`${environment.apiEndpoint}/account/client-note/${clientId}`);
  }

  public updateClientNote(clientId: string, noteId: number, body: string): Observable<void> {
    return this.http.put<void>(`${environment.apiEndpoint}/account/client-note/${clientId}/${noteId}`, body);
  }

  public deleteClientNote(clientId: string, noteId: number): Observable<void> {
    return this.http.delete<void>(`${environment.apiEndpoint}/account/client-note/${clientId}/${noteId}`);
  }

  public createClientNoteAttachment(clientId: string, noteId: number, file: File): Observable<HttpResponse<string>> {
    return this.http
      .post(`${environment.apiEndpoint}/account/client-note/${clientId}/${noteId}/attachment`, {
        responseType: 'text',
      })
      .pipe(
        concatMap((uploadUrl: string) =>
          this.http.put(uploadUrl, file, {
            headers: {
              'Content-Type': file.type,
              'x-amz-acl': 'private',
              'Content-Disposition': `attachment; filename="${file.name}"`,
            },
            observe: 'response',
            responseType: 'text',
          }),
        ),
      );
  }

  public deleteClientNoteAttachment(clientId: string, noteId: number, attachmentId: number): Observable<void> {
    return this.http.delete<void>(
      `${environment.apiEndpoint}/account/client-note/${clientId}/${noteId}/attachment/${attachmentId}`,
    );
  }
}
